import React from "react";
import { Button, Input } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AuthLayout from "../login/AuthLayout";

const ForgotPassword = () => {
  const { t } = useTranslation("dashboard");
  const config = "/";
  return (
    <AuthLayout>
      <h1 className="auth-page__title">{t("Forgot Password?")}</h1>
      <p className="auth-page__subtitle">{t("Enter your email to get a password reset link")}</p>
      <form action={`${config}admin/login`}>
        <div className="auth-page__field">
          <label className="auth-page__label" htmlFor="forgot-email">
            {t("Email")}
          </label>
          <Input
            id="forgot-email"
            name="email"
            type="email"
            inputMode="email"
            autoComplete="email"
            autoCapitalize="none"
            spellCheck={false}
            size="large"
            placeholder={t("Email")}
          />
        </div>
        <Button type="primary" htmlType="submit" size="large" block>
          {t("Reset Password")}
        </Button>
      </form>
      <div className="auth-page__footer">
        {t("Remember your password?")} <Link to="/login">{t("Login")}</Link>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
